var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// import frenchMessages from 'ra-language-french';
import chineseMessages from 'ra-language-chinese';
var customChineseMessages = __assign(__assign({}, chineseMessages), { error: {
        common: {
            tryAgain: "錯誤：請重試",
            getFailed: "錯誤：取得資料失敗",
        },
        subject: {
            subId: "錯誤：此組織中已存在具有此 ID，請使用其他的 ID",
            org: "錯誤：該組織 ID 不屬於任何組織",
            NotFoundException: "錯誤：未找到此 ID",
            delFailed: "錯誤：受試者刪除失敗",
        },
        exam: {
            delFailed: "錯誤：測試刪除失敗"
        },
        ACL: {
            getACLFailed: "錯誤：取得 ACL 失敗",
            unauthorized: "錯誤：沒有權限",
        },
        login: {
            banned: "錯誤： 您的IP已被禁用",
            chancesLeft: "次机会",
            tryAgain: "錯誤：請重試",
            invalidToken: "錯誤：2FA 驗證碼不正確。請檢查並重試",
            accNotAct: "錯誤：帳戶未激活",
            PWNotSame: "錯誤：密碼不匹配。請確保兩次輸入的密碼完全相同",
            email: "錯誤：請輸入有效的電子郵件地址",
            sameEmail: "錯誤：電子郵件已被使用，請嘗試使用其他電子郵件",
            invalidPWType: "錯誤：密碼長度最小為8位，不允許有空格，並且由字母、數字或特殊字元!@#$%^&*()組成",
            allSame: "錯誤：電子郵件或使用者名稱已使用，請嘗試另一個",
            emailNotExist: "錯誤：此電子郵件地址不屬於任何註冊用戶。請檢查電子郵件或註冊新帳戶。",
            invalidCredentials: "登录失败，还剩",
            registerFailed: "錯誤：註冊失敗，憑證無效",
            enterPW: "請輸入密碼",
            failSendEmail: "錯誤：發送電子郵件失敗",
            emailFieldEmpty: "錯誤：電子郵件欄不能為空。請輸入您的電子郵件地址。",
            setNewPWFailed: "錯誤：設定新密碼失敗，憑證無效",
        },
        dashboard: {
            fetchData: "錯誤：取得儀表板資料時出錯",
        },
        settings: {
            dupEmailUsn: "錯誤：設定更新失敗，電子郵件或使用者名稱重複",
            curPW: "錯誤：目前密碼不正確",
            newPW: "錯誤：新密碼不匹配",
            PW: "錯誤：設定更新失敗，請仔細檢查密碼",
            noUser: "錯誤：找不到用戶",
        },
        fp: {
            uploadFailed: "錯誤：眼底照片上傳失敗",
            fpAnlysis: "錯誤：測試分析錯誤，請更換照片",
            updateFailed: "錯誤：照片更新失敗",
            uploadPDFFailed: "錯誤：PDF上傳失敗",
            notFound: "錯誤：找不到眼底照片照片 ID",
            examNotFound: "錯誤：找不到測試",
            aiclassify: "使用Convnext模型分類照片失敗，請上傳適合的照片",
            AI: {
                subId: "錯誤：受試者 ID 無效",
                examId: "錯誤：測試 ID 無效",
            },
        },
        imageChecker: {
            noUrl: "錯誤：未提供圖片網址",
            notHttps: "警告：基於安全考量，圖片網址應使用HTTPS協議",
            differentOrigin: "警告：圖片網址來自不同來源 ({{imageOrigin}} vs {{currentOrigin}})",
            invalidUrl: "錯誤：無效的圖片網址格式",
            noCookieToken: "警告：Cookie中找不到存取權杖，使用localStorage備援",
            noAccessToken: "錯誤：Cookie和localStorage中都找不到存取權杖，請重新登入",
            tokenExpired: "警告：存取權杖已過期，嘗試繼續載入",
            invalidToken: "警告：無效的存取權杖格式，嘗試繼續載入",
            loadFailed: "錯誤：從伺服器載入圖片失敗",
            unknown: "錯誤：未知的圖片載入錯誤",
        },
        dataExport: {
            exportFail: "錯誤：資料匯出失敗",
        },
        userList: {
            delFail: "錯誤：用戶刪除失敗",
            createFail: "錯誤：用戶建立失敗",
            createDupFail: "錯誤：使用者建立失敗，電子郵件或使用者名稱重複",
            updateFail: "錯誤：使用者更新失敗，電子郵件或使用者名稱重複",
            getFail: "錯誤：獲取資料失敗",
            disableFail: "錯誤：停用用戶失敗",
            invalidBoth: "錯誤：使用者群組或組織的資料無效",
            invalidOrg: "錯誤：組織資料無效",
            invalidUserGroups: "錯誤：用戶群組資料無效",
            noUserID: "錯誤：沒有使用者擁有此使用者 ID",
        },
        organization: {
            getUserOrgFailed: "錯誤：取得使用者組織失敗",
            dupEmailUsn: "錯誤：用戶更新失敗，電子郵件或使用者名稱重複",
            createFailed: "錯誤：組織建立失敗",
            updateFailed: "錯誤：組織更新失敗",
            delFailed: "錯誤：組織刪除失敗",
            getParamsFailed: "錯誤：組織取得參數失敗",
            validOrg: "錯誤：請輸入有效的組織名稱",
            nameUsed: "錯誤：該組織名稱已被使用，請考慮使用其他名稱",
            noId: "錯誤：該組織 ID 不屬於任何組織",
            notOpen: "錯誤：該組織並未對所有人開放",
            userGroup: {
                updateFail: "錯誤：使用者群組更新失敗",
                createFail: "錯誤：使用者群組建立失敗",
                delFail: "錯誤：使用者群組刪除失敗",
                noUserId: "錯誤：該用戶 ID 不屬於任何用戶",
                wrongGroup: "錯誤：某些使用者群組不屬於該組織",
                sameName: "錯誤：此組織中存在使用相同名稱的使用者群組",
                notFound: "錯誤：找不到用戶群組",
                notBelong: "錯誤：該使用者不屬於該組織",
            },
        }
    }, "login": {
        notify: {
            digitCode: "已發送 6 位代碼",
            resetSuccess: "重置密碼成功",
        },
        "username": "用戶名",
        "password": "密碼",
        "email": "電子郵件",
        "authenCode": "6位驗證碼",
        "YourEmail": "你的電郵",
        "didntReceive": "未收到？",
        "AI_Screening_Platform": "AI 篩查平台",
        "signIn": "登入",
        "register": "註冊",
        "resend": "重新發送",
        "emailSent": "已發送電郵",
        "forgetPW": {
            "caption": {
                "willSendEmail": "將發送一封電子郵件到您的郵箱以啟動密碼重置過程。",
                "sentEmail": "已發送郵件到您的郵箱。請檢查您的郵箱以繼續密碼重置過程。",
                "notReceiveEmail": "未收到郵件？",
                "willSend2fa": "將發送一封帶有時限的 6 位驗證碼的電子郵件到您的郵箱。請輸入驗證碼以登入。"
            }
        },
        "resetPW": {
            "caption": {
                "inputPW": "請輸入新密碼。"
            }
        },
        "SignUpNow": "註冊",
        "ForgetYourPassword": "忘記密碼？",
        "ForgetPassword": "忘記密碼",
        "ResetPassword": "重設密碼",
        "YourPassword": "您的密碼",
        "YourUsername": "您的用戶名",
        "ConfirmPassword": "確認密碼",
        "BackToSignIn": "返回登入"
    }, "breadcrumb": {
        "main": "主頁",
        "userManagement": "用戶管理"
    }, "fp": {
        "left_eye": "左眼",
        "right_eye": "右眼",
        "macula_centered": "黃斑中心",
        "disc_centered": "視盤中心",
        "gradableFp": "可分析的眼底照片",
        "ungradableFp": "不可分析的眼底照片 / 不可分類的眼底照片",
        "comment": "評論（如果有）",
        "ungradableImage": "不可分析的照片",
        "gradableImage": "可分析的照片",
        "fundusPhotos": "眼底照片",
        "pleaseUploadTheFundusPhotos": "請上傳視網膜照片。",
        "dragImagesHere": "拖拽視網膜照片(最多10張)",
        "dragImagesHere2": "拖拽視網膜照片",
        "supportedFileType": "支持的文件類型：.jpg, .png",
        "fileSize": "文件大小:最多10 MB",
        "quotaLeft": "剩餘配額",
        "saveBeforeUpload": "請確保在上傳新圖像之前保存您的更改，以免失去您所做的更改！",
        notify: {
            uploaded: "文件已上傳",
            updated: "照片已更新",
        },
        /*  message:{
             both: "左眼和右眼都可以分析。",
             onlyright: "(✓右眼 ✘左眼) 右眼可以分析。由於缺少圖像或圖像不可分析，左眼無法分析。",
             onlyleft: "(✘右眼 ✓左眼) 左眼可以分析。由於缺少圖像或圖像不可分析，右眼無法分析。",
             none: "兩隻眼睛都無法分析。請確保至少一隻眼睛上傳了一張可分析的黃斑中心圖像和一張可分析的視盤中心圖像。",
             toomuch: "在同一位置檢測到多張可分析的圖像。請確保每隻眼睛的每個位置（黃斑/視盤）只保留一張可分析的圖像。",
         }, */
    }, pagniation: {
        rowsPerPage: "每页行数: ",
        "of": " / "
    }, "components": {
        "ai_results": "AI 結果",
        "data_import": "數據導入",
    }, "tooltip": {
        "viewSubject": "查看受試者",
        "viewExam": "查看測試",
        "viewUser": "查看用戶",
        "editSubject": "編輯受試者",
        "editExam": "編輯測試",
        "editUser": "編輯用戶",
        "editAccessRight": "編輯訪問權限",
        "editGroup": "編輯群組",
        "deleteSubject": "刪除受試者",
        "deleteExam": "刪除測試",
        "deleteUser": "刪除用戶",
        "deleteOrg": "刪除組織",
        "deleteGroup": "刪除群組",
        "importData": "導入數據",
        "shareReport": "分享報告",
        "viewAndEditOrg": "查看和編輯組織",
        "viewOrg": "查看組織",
        "checkOutUser": "前往用戶",
        "disableUser": "禁用用戶",
    }, "comfirmDialog": {
        "subject": "您確定要刪除這個受試者嗎？",
        "exam": "您確定要刪除這個測試嗎？",
        "user": "您確定要刪除這個用戶嗎？",
        "organization": "您確定要刪除這個組織嗎？",
        "group": "您確定要刪除這個群組嗎？",
        "disableUser": "您確定要禁用這個用戶嗎？"
    }, "pos": {
        "search": "搜索",
        "configuration": "配置",
        "language": "語言",
        "english": "英文",
        "chinese": "中文",
        "theme": {
            "name": "主題",
            "light": "淺色",
            "dark": "深色"
        },
        "menu": {
            "files": "文件",
            "main": "主頁",
            "userManagement": "用戶管理"
        }
    }, params: {
        exams: {
            eye: {
                Left: "左眼",
                Right: "右眼",
                Both: "雙眼",
            },
            outcome: {
                high: "高",
                High: "高",
                Low: "低",
                null: "未完成",
            },
            status: {
                Pending: "未完成",
                "In progress": "進行中",
                Completed: "完成",
            },
        },
        subjects: {
            unkown: "未知",
            yrs: "年",
            M: "男",
            F: "女",
            "Prefer not to disclose": "寧願不透露",
            // edu lvl
            'Unknown': '未知',
            '0-3 yrs': '0-3 年',
            '4-6 yrs': '4-6 年',
            '7-9 yrs': '7-9 年',
            '10-12 yrs': '10-12 年',
            '> 12 yrs': '> 12 年',
        },
        users: {
            Active: "活躍",
            active: "活躍",
            disabled: "禁用",
            Disabled: "禁用",
            'Not activate': "未激活",
            "Inactive": "未激活"
        },
        dashboard: {
            years: {
                '0-20y': '0-20年',
                '20-40y': '20-40年',
                '40-60y': "40-60年",
                '60-80y': "60-80年",
                '>80y': ">80年",
            },
            paymentRecord: {
                Pending: "未完成",
                Completed: "已完成",
            },
            TotalSubjects: "總受試者",
            HighRiskSubjects: "高風險受試者",
        },
        settings: {
            package: {
                'Advanced package': "高級套餐",
                'Standard package': "標準套餐",
                'Basic package': "基本套餐",
            },
        },
    }, "common": {
        "search": "搜索",
        "clear": "清除",
        "save": "保存",
        "analyze": "分析腦部健康",
        "leave": "離開",
        "close": "關閉",
        "confirm": "確認",
        "back": "返回",
        "selectAll": "全選",
        "unselectAll": "重置",
        "fillInAll": "請填寫所有資訊",
        "classify": "評估照片質量",
        "unsavedChanges": "您的更改尚未保存。您確定要離開此頁面嗎？",
        "closeWithoutSaving": "離開不保存",
        "saveAndClose": "保存並離開",
    }, "dialog": {
        "export": "導出",
        "exportSubjects": "導出受試者",
        "submit": "提交",
        "submit_and_import": "提交並導入數據",
        "Edit": "編輯",
        "Create": "創建"
    }, "pages": {
        "common": {
            "selection": {
                "select_all": "全選",
                "reset": "重置",
                "select": "選擇"
            }
        },
        cooperation: {
            stats: {
                totalCompanies: "總公司數",
                totalApiCalls: "總API調用次數",
                activeCompanies: "活躍公司數",
            },
            company: {
                showStatistics: "顯示統計",
                apiAccess: "API訪問",
                apiStatus: "API狀態",
                enabled: "已啟用",
                disabled: "已禁用",
                totalApiCalls: "總API調用次數",
            },
            charts: {
                monthlyApiAccess: "月度API訪問",
                apiAccessDistribution: "API訪問分佈",
            },
            dialog: {
                confirmDisableTitle: "確認禁用API訪問",
                confirmDisableMessage: "您確定要禁用API訪問嗎？這將阻止他們進行任何API調用。",
                cancel: "取消",
                disableAccess: "禁用訪問",
            },
            notify: {
                enableSuccess: "API訪問已成功啟用",
                enableError: "啟用API訪問時出錯",
                disableSuccess: "API訪問已成功禁用",
                disableError: "禁用API訪問時出錯",
            },
        },
        postPayment: {
            paymentSuccess: "✔ 付款成功",
            paymentFail: "✘ 付款失敗",
            loading: "載入中...",
            backToSubjects: "返回受試者頁面",
            processingPayment: "處理付款",
            paymentStatus: "付款狀態",
            successMessage: "付款成功！ 您已成功購買: ",
            failureMessage: "付款失敗。",
            pleaseWait: "請稍候...",
            leftQuota: "剩餘配額",
            invoiceUploaded: "發票已下載並上傳",
        },
        "subject": {
            "name": "受試者",
            "title": "受試者",
            "ViewSubject": "查看受試者",
            "notify": {
                "updated": "受試者已更新",
                "updateFailed": "錯誤：受試者更新失敗",
                "get": "受試者獲取成功",
                "getFailed": "錯誤：受試者獲取失敗",
                "added": "受試者添加成功",
                "addFailed": "錯誤：受試者添加失敗",
                "deleted": "受試者刪除成功",
            },
            "fields": {
                "info": "受試者信息",
                "customId": "ID",
                "id": "受試者 ID",
                "firstname": "名字",
                "lastname": "姓氏",
                "gender": "性別",
                "dateOfBirth": "出生日期",
                "dateOfBirthFrom": "出生日期 - 從",
                "dateOfBirthTo": "出生日期 - 到",
                "educationLevel": "教育水平",
                "actions": "操作",
                "examFromDate": "測試 - 從",
                "examToDate": "測試 - 到",
                "analyzeFromDate": "分析 - 從",
                "analyzeToDate": "分析 - 到",
                "firstIndexExamConfidence_level": "最新測試的信賴區間",
                "risk": "風險"
            },
            "addNew": "添加新受試者"
        },
        "bulkGeneration": {
            "name": "批量生成",
            "description": "匯入、預覽及批量生成報告，或查看您的批次記錄。",
            "sections": {
                "operation": "操作",
                "history": "記錄"
            },
            "stages": {
                "upload": "上傳",
                "preview": "預覽",
                "generate": "生成",
                "uploadDescription": "上傳包含受試者及測試資料的 ZIP 檔案以進行匯入。",
                "previewDescription": "在生成報告前，檢視已匯入的受試者及測試資料。",
                "generateDescription": "為每個成功匯入的測試生成一份報告。"
            },
            "fields": {
                "name": "設置批次名稱 (可選)",
                "archive": "ZIP 檔案"
            },
            "dropzone": {
                "prompt": "拖放 ZIP 檔案到此處，或點擊選擇",
                "hint": "只支援 .zip 檔案（最大 2 GB）"
            },
            "actions": {
                "upload": "上傳並排隊",
                "uploading": "上傳中...",
                "replace": "更換 ZIP 檔案",
                "remove": "移除 ZIP 檔案",
                "generate": "生成報告",
                "refresh": "重新整理",
                "download": "下載原始 ZIP",
                "view": "查看詳情",
                "retryImport": "重試匯入",
                "retryReports": "重試失敗報告",
                "regenerateFailedReports": "重新生成失敗報告",
                "continueGenerate": "繼續生成報告",
                "confirmGenerate": "確認生成報告",
                "regenerateBatch": "重新生成整批報告",
                "regenerateExam": "重新生成此測試報告",
                "viewReport": "查看目前報告",
                "downloadReports": "下載成功生成的報告",
                "delete": "刪除批次",
                "deleteUnavailable": "進行中的批次無法刪除",
                "backToUpload": "返回"
            },
            "notify": {
                "selectFile": "請選擇 ZIP 檔案",
                "uploaded": "批次已上傳並加入匯入隊列",
                "uploadFailed": "錯誤：批次上傳失敗",
                "invalidType": "只允許 ZIP 檔案",
                "tooLarge": "檔案超過 2 GB 限制",
                "previewFailed": "無法載入批次預覽",
                "historyFailed": "無法載入批次記錄",
                "downloadFailed": "下載壓縮檔失敗",
                "reportQueued": "報告已加入生成隊列",
                "reportFailed": "無法開始生成報告",
                "retryFailed": "無法開始重試",
                "examRegenerated": "測試報告已重新生成",
                "examRegenerateFailed": "無法重新生成測試報告",
                "reportDownloadFailed": "無法下載成功生成的報告",
                "deleted": "批次已刪除",
                "deleteFailed": "無法刪除批次"
            },
            "delete": {
                "title": "刪除批次",
                "content": "要從批次記錄中刪除「%{name}」嗎？其批次連結、工作及任務將被刪除。已匯入的受試者及測試會保留。"
            },
            "status": {
                "UPLOADING": "上傳中",
                "UPLOADED": "已上傳",
                "QUEUED": "排隊中",
                "PROCESSING": "處理中",
                "IN_PROGRESS": "進行中",
                "COMPLETED": "已完成",
                "COMPLETED_WITH_ERRORS": "完成但有錯誤",
                "FAILED": "失敗",
                "PENDING": "等待中",
                "SUCCESS": "成功"
            },
            "progress": {
                "overall": "整體進度",
                "import": "匯入進度",
                "report": "報告生成進度",
                "total": "總數",
                "success": "成功",
                "inProgress": "進行中",
                "fail": "失敗",
                "importing": "正在匯入壓縮檔，進度會自動更新。",
                "generating": "正在生成報告，進度會自動更新。",
                "noSuccessfulReports": "沒有可下載的成功報告。"
            },
            "quota": {
                "label": "剩餘配額："
            },
            "preview": {
                "title": "預覽",
                "empty": "目前未有受試者資料。",
                "row": "Excel 第 %{row} 行",
                "image": "測試影像",
                "noImages": "此測試未有連結影像。",
                "noImage": "沒有影像",
                "rightEye": "右眼",
                "leftEye": "左眼",
                "centered": "黃斑置中",
                "notCentered": "黃斑未置中",
                "subjectInformation": "受試者資料",
                "sourceRow": "Excel 行數",
                "customId": "受試者編號",
                "name": "姓名",
                "gender": "性別",
                "educationLevel": "教育程度",
                "dateOfBirth": "出生日期",
                "examDate": "測試日期",
                "aiModel": "AI 模型",
                "eye": "眼睛",
                "subjectImportStatus": "受試者匯入狀態",
                "examImportStatus": "測試匯入狀態",
                "examStatus": "測試狀態"
            },
            "generate": {
                "description": "為每個成功匯入的測試生成一份報告。"
            },
            "history": {
                "title": "我的批次記錄",
                "empty": "您目前未有批次記錄。",
                "noResults": "沒有符合目前篩選條件的批次記錄。",
                "search": "搜尋批次名稱或 ZIP 檔案",
                "batchName": "批次名稱",
                "archive": "原始 ZIP",
                "created": "建立時間",
                "createdFrom": "建立時間 - 從",
                "createdTo": "建立時間 - 到",
                "importStatus": "匯入狀態",
                "reportStatus": "最新報告",
                "actions": "操作"
            }
        },
        "exam": {
            "name": "測試",
            "title": "測試",
            "allExamDate": "所有測試日期",
            notify: {
                updated: "測試已更新",
                updateFailed: "測試更新失敗",
                get: "測試獲取成功",
                getFailed: "測試獲取失敗",
                added: "測試添加成功",
                addFailed: "測試添加失敗",
                deleted: "測試刪除成功",
            },
            "fields": {
                params: {
                    eye: {
                        Left: "左眼",
                        Right: '右眼',
                        Both: "雙眼"
                    },
                    ai_model: {
                        'FP': '眼底照片',
                        'OCT': 'OCT 報告',
                        'FP + OCT': '眼底照片 + OCT 報告'
                    },
                    risk_of_ad: {
                        'High': '高',
                        'Low': '低',
                    },
                    status: {
                        'Pending': '未完成',
                        'In progress': '進行中',
                        'Completed': '已完成',
                    },
                },
                "exam_date": "測試日期",
                "ai_model": "AI 模型",
                "model": "模型",
                "eye": "眼睛",
                "risk_of_ad": "結果",
                "confidence_level": "信賴水平",
                "confidence_level_avg": "最新信賴水平",
                "status": "狀態",
                "analysisDate": "分析日期",
                "actions": "操作",
                "customId": "ID",
                "subject_id": "受試者 ID",
                "id": "測試 ID",
                "firstname": "名字",
                "lastname": "姓氏",
                "gender": "性別",
                "dateOfBirth": "出生日期",
                "educationLevel": "教育水平",
                "examFromDate": "測試 - 從",
                "examToDate": "測試 - 到",
                "analyzeFromDate": "分析 - 從",
                "analyzeToDate": "分析 - 到"
            },
            "dialog": {
                "edit_exam": "編輯測試",
                "add_new_exam": "添加新測試"
            },
            "share": {
                "title": "分享 AI 報告",
                "email": "電郵",
                "qrCode": "二維碼",
                "destinationEmail": "收件人電郵",
                "send": "發送",
                "generateQr": "生成二維碼",
                "confirmGenerateQr": "生成二維碼",
                "regenerateQr": "重新生成",
                "downloadQrCode": "下載二維碼",
                "qrDownloaded": "二維碼已下載",
                "qrDownloadFailed": "下載二維碼失敗",
                "validityMinutes": "有效期（分鐘）",
                "invalidQrSettings": "請輸入有效的下載次數和有效期",
                "qrHint": "掃描二維碼以下載報告",
                "expiresAt": "到期日期及時間",
                "downloadLimit": "允許下載次數",
                "copyLink": "複製連結",
                "linkCopied": "連結已複製",
                "emailSent": "報告已成功發送",
                "emailSentWithPassword": "報告連結已發送，6 位數密碼將另以電郵發送。",
                "emailFailed": "發送報告失敗",
                "qrFailed": "生成二維碼失敗",
                "invalidEmail": "請輸入有效的電郵地址",
                "emailLinkDeliveryReminder": "含有報告連結的電郵送達時間會稍長。",
                "emailDeliveryReminder": "電郵可能需要約 3 至 5 分鐘才會送達，請設定足夠的有效時間。",
                "passwordRequired": "需要密碼才能存取",
                "accessPassword": "存取密碼",
                "copyPassword": "複製密碼",
                "passwordCopied": "密碼已複製"
            },
            "shareReportPage": {
                "platform": "AI 篩查平台",
                "title": "腦部健康報告",
                "loading": "正在載入報告詳情...",
                "download": "下載報告",
                "downloading": "正在下載...",
                "error": "無法載入報告詳情。",
                "expired": "此連結已過期或已達下載次數上限。",
                "downloadError": "無法下載報告。",
                "subjectId": "受試者編號",
                "examDate": "測試日期",
                "aiModel": "AI 模型",
                "eye": "眼睛",
                "expiresAt": "連結到期時間",
                "downloadLimit": "允許下載次數",
                "passwordHint": "請輸入 QR 碼分享時提供的 6 位數密碼。",
                "passwordRequired": "請輸入密碼。",
                "invalidPassword": "密碼不正確。",
                "invalidPasswordFormat": "請輸入完整的 6 位數密碼。"
            },
            "fp": {
                "summaryReport": "一頁摘要報告",
                "detailedReport": "詳細報告",
                "analyzeCases": {
                    "cases": "可分析的案例：",
                    "both": "1. 雙眼：黃斑中心和視盤中心的左右眼照片",
                    "leftOnly": "2. 僅左眼：黃斑中心和視盤中心的左眼照片",
                    "rightOnly": "3. 僅右眼：黃斑中心和視盤中心的右眼照片"
                },
                resTextCases: {
                    "both": "右眼和左眼都可以進行分析。",
                    "none": "右眼和左眼都不能進行分析。請上傳另一組圖像。",
                    "toomuch": "只會使用左或右眼的一個可分析的黃斑中心和一個可分析的視盤中心進行分析。請更新圖像的定位。",
                    "lackRight-macula": "右眼不能進行分析，因為缺少黃斑中心的圖像。",
                    "lackRight-disc": "右眼不能進行分析，因為缺少視盤中心的圖像。",
                    "lackRight-both": "右眼不能進行分析，因為缺少黃斑中心和視盤中心的圖像。",
                    "lackLeft-macula": "左眼不能進行分析，因為缺少黃斑中心的圖像。",
                    "lackLeft-disc": "左眼不能進行分析，因為缺少視盤中心的圖像。",
                    "lackLeft-both": "左眼不能進行分析，因為缺少黃斑中心和視盤中心的圖像。",
                },
            },
        },
        "dataExport": {
            "name": "數據導出",
            "criteria": "數據導出標準",
            notify: {
                select: "請選擇欄位!",
                exported: "數據導出成功",
            },
            "fields": {
                "group_subjects": "受試者信息總和",
                "subject_information": "受試者信息",
                "images": "照片",
                "fps": "眼底照片",
                "fp": "眼底照片",
                "oct_reports": "OCT 報告",
                "retinAD_reports": "RetinAD 報告",
                "oct": "OCT 報告",
                "fp_oct": "眼底照片 + OCT 報告",
                "retinAD_probability_scores": "RetinAD 概率分數",
                "internal_use": "僅供內部使用",
                "questionnaire_results": "問卷結果",
                "latest_risk": "最新風險",
                "examDate": "測試",
                "analyzeDate": "分析",
                "dateFrom": "從",
                "dateTo": "至",
            },
            "dialog": {
                "subjects_selected": "選擇的主題數量："
            }
        },
        "settings": {
            "name": "設定",
            "notify": {
                "updated": "設定已更新",
                "newPW": "請輸入新密碼",
                "curPW": "請輸入目前密碼",
                "newPWNotSame": "新密碼與確認新密碼不同",
            },
            "leftCol": {
                "profile": "個人資料",
                "language": "語言",
                "security": "安全",
                "membership": "會員",
                "payment": "付款",
                "package": "套餐",
            },
            "fields": {
                "profile": {
                    "headers": {
                        "info": "基本信息",
                        "set_new_pw": "設定新密碼",
                        "access": "查看您的訪問權限",
                        "accessRight": "訪問權限"
                    },
                    "info": {
                        "id": "ID",
                        "user_id": "用戶 ID",
                        "user_group": "用戶群組",
                        "username": "用戶名",
                        "name": "姓名",
                        "firstname": "名字",
                        "lastname": "姓氏",
                        "gender": "性別",
                        "email": "電子郵件"
                    },
                    "password": {
                        "current": "當前密碼",
                        "new": "新密碼",
                        "confirm_new": "確認新密碼"
                    },
                    "access": {
                        "dashboard": "儀表板",
                        "user_group": "用戶群組",
                        "subject": "主題",
                        "data_export": "數據導出"
                    },
                    "crud": {
                        "c": "新增",
                        "r": "查看",
                        "u": "編輯",
                        "d": "刪除"
                    }
                },
                "language": {
                    "lan_caption": "更改語言顯示設置"
                },
                "security": {
                    "header2fa": "雙重身份驗證",
                    "caption2fa": "添加額外的安全步驟來登入，需要您輸入發送到設備上的限時 6 位數字代碼以驗證身份。"
                },
            },
        },
        "membership": {
            "btn": {
                "cancel": "取消",
                "renew": "續訂",
                "subsMonth": "訂閱（月）",
                "subsYear": "訂閱（年）",
                "purchase": "購買",
            },
            "fields": {
                "plans": {
                    "genLeft": " 剩餘次數",
                    "currentPlan": "當前計劃",
                    "advanced": "高級",
                    "monthly": "每月",
                    "yearly": "每年",
                    "caption": "* 除非您選擇取消訂閱，否則您的會員資格將在到期時自動續訂。"
                },
                "headers": {
                    "current": "當前計劃",
                    "basic": "基本",
                    "standard": "標準",
                    "advanced": "高級",
                    "premium": "高端"
                },
                "details": {
                    "subsPreTermsAndCond": "訂閱即表示您同意我們的",
                    "termsAndCond": "條款和條件。",
                    "unlimited": "無限",
                    "genMonthly": "AI 報告生成次數",
                    "day": "日",
                    "month": "月",
                    "year": "年",
                    "save2monthfee": "節省兩個月費用"
                },
            },
        },
        "payment": {
            "fields": {
                "addNew": "增加新信用卡",
                "addNewPackage": "添加新套餐",
            }
        },
        "userList": {
            "name": "用戶",
            "group": "群組",
            "listName": "用戶列表",
            "ViewUser": "查看用戶",
            notify: {
                delete: "用戶已刪除",
                added: "用戶已建立",
                updated: "用戶已更新",
                get: "用戶已獲取",
                disabled: "用戶已停用",
                fillInUserGroup: "請填寫使用者群組",
            },
            "fields": {
                "id": "用戶 ID",
                "userGroup": "用戶群組",
                "username": "用戶名",
                "organization": "組織",
                "email": "電子郵件",
                "status": "狀態",
                "createdAt": "創建時間",
                "updatedAt": "更新時間",
                "pw": "密碼",
                "confirmpw": "確認密碼"
            },
            "addNew": "添加新用戶",
            "info": "用戶信息"
        },
        "organizations": {
            "name": "組織",
            notify: {
                delete: "組織已刪除",
                create: "組織已創建",
                update: "組織已更新",
                get: "組織已獲取",
                enterGroup: "請輸入群組名稱",
                userGroup: {
                    update: "已更新使用者群組",
                    add: "已創建使用者群組",
                    delete: "已刪除使用者群組"
                }
            },
            "editComp": {
                "general": "一般",
                "groups": "群組",
                "users": "用戶",
                "group": "群組"
            },
            "fields": {
                "orgId": "組織 ID",
                "id": "群組 ID",
                "userGroup": "用戶群組",
                "username": "用戶名",
                "organization": "組織",
                "orgName": "組織名稱",
                "groupNum": "群組數量",
                "groupName": "群組名稱",
                "userNum": "用戶數量",
                "email": "電子郵件",
                "status": "狀態",
                "createdAt": "創建時間",
                "updatedAt": "更新時間"
            },
            "addNew": "添加新組織",
            "availableUsersInOrg": "組織中的可用用戶 ",
            "noUsersInOrganization": "組織中沒有可用用戶",
            "userIn": "用戶在 ",
            "selected": "選擇",
            "addNewGroup": "添加新群組",
            "addNewUser": "為此組織創建新用戶",
            "info": "用戶信息",
            "groupList": {
                "fields": {
                    "name": "群組名稱"
                }
            },
            "userList": {
                "group": "群組",
                "accessRight": "訪問權限",
                "filters": { "userId": "用戶 ID" },
                "fields": {
                    "name": {
                        "dashboard": "儀表板",
                        "user": "用戶",
                        "organization": "組織",
                        "subjects": "主題",
                        "dataExport": "數據導出"
                    },
                    "dashboard": {
                        "gen": "查看綜合分析",
                        "sales": "查看銷售分析"
                    },
                    "user": {
                        "viewAll": "查看所有用戶",
                        "viewOrg": "查看組織用戶",
                        "create": "創建新用戶",
                        "edit": "編輯所有用戶",
                        "editOrg": "編輯組織用戶",
                        "disable": "禁用用戶"
                    },
                    "organization": {
                        "viewAll": "查看所有組織",
                        "viewOwn": "查看您的組織",
                        "create": "創建新組織",
                        "disable": "禁用所有組織",
                        "disableOwnOrg": "禁用您的組織",
                        "edit": "編輯所有組織",
                        "editOwn": "編輯您的組織",
                        "editGroup": "編輯所有組織群組",
                        "editOwnGroup": "編輯您的群組",
                        "addGroup": "添加新群組",
                        "disableGroup": "禁用所有群組",
                        "disableOwnGroup": "禁用您的群組",
                        "disableOrg": "禁用組織用戶",
                        "createNewOrg": "創建新組織用戶"
                    },
                    "subjects": {
                        "view": "查看所有受試者",
                        "viewOrg": "查看組織受試者",
                        "create": "創建新受試者",
                        "edit": "編輯受試者",
                        "delete": "刪除受試者"
                    },
                    "dataExport": {
                        "all": "導出所有主題的數據",
                        "org": "導出組織主題的數據",
                        "retinAD": "導出 RetinAD 概率分數"
                    }
                },
            },
        },
        "package": {
            "fields": {
                "name": "名稱",
                "price": "價格",
                "quota": "配額",
                "description": "描述",
            }
        },
        "dashboard": {
            "name": "儀表板",
            "amount": "1 條評論 |||| %{smart_count} 條評論",
            "relative_to_poster": "海報上的評論",
            "detail": "評論詳情",
            "fields": {
                "customer_id": "顧客",
                "command_id": "訂單",
                "product_id": "產品",
                "date_gte": "發布自",
                "date_lte": "發布至",
                "date": "日期",
                "comment": "評論",
                "rating": "評分"
            },
            "action": {
                "accept": "接受",
                "reject": "拒絕"
            },
            "notification": {
                "approved_success": "評論已批准",
                "approved_error": "錯誤：評論未批准",
                "rejected_success": "評論已拒絕",
                "rejected_error": "錯誤：評論未拒絕",
                "noData": "沒有數據"
            },
            "title": {
                "bannedIP": "禁止 IP",
                "allOrganizations": "所有組織",
                "yourOrganization": "您的組織",
                "revenueReport": "收入報告",
                "totalSubjects": "總受試者",
                "totalExams": "總測試",
                "generatedReports": "已生成報告",
                "advancedYearly": "高級 - 年",
                "unfinishExams": "未完成測試",
                "finishedExams": "已完成測試",
                "cbu": "由您創建",
                "iuo": "在您的組織中",
                "until20241231": "直到 2024/12/31",
                barChart1: "所有組織中按年齡組分的總受試者和高風險受試者",
                barChart2: "您的組織中按年齡組分的總受試者和高風險受試者",
                "redlist1": "所有組織中的近期高風險受試者",
                "redlist2": "您的組織中的近期高風險受試者",
                "pie1": "完成測試中信心水平分佈",
                "pie2": "完成測試中眼睛分佈",
                "pie3": "完成測試中 AI 模型分佈",
                "pie4": "性別分佈",
                "pie5": "教育水平分佈",
                "pie6": "年齡組分佈",
                "total": "總計："
            },
        },
    }, version: "版本", acl: {
        organization_admin: {
            create: "創建組織",
            view: "查看組織",
            update: "編輯組織",
            delete: "刪除組織",
        },
        organization_normal: {
            view: "查看組織",
            update: "編輯組織",
            delete: "刪除組織",
        },
        user_admin: {
            create: "創建用戶",
            view: "查看用戶",
            update: "編輯用戶",
            delete: "刪除用戶",
        },
        user_normal: {
            create: "創建用戶",
            view: "查看用戶",
            update: "更新用戶",
            delete: "刪除用戶",
        },
        subject_admin: {
            create: "創建受試者",
            view: "查看受試者",
            update: "更新受試者",
            delete: "刪除受試者",
        },
        subject_normal: {
            create: "創建受試者",
            view: "查看受試者",
            update: "編輯受試者",
            delete: "刪除受試者",
        },
        user_group_admin: {
            create: "創建用戶群組",
            view: "查看用戶群組",
            update: "更新用戶群組",
            delete: "刪除用戶群組",
        },
        user_group_normal: {
            create: "創建用戶群組",
            view: "查看用戶群組",
            update: "編輯用戶群組",
            delete: "刪除用戶群組",
        },
        data_export_admin: {
            export: "導出數據",
        },
        data_export_normal: {
            export: "導出數據",
            export_retinad_probability_scores: "導出RetinAD",
        },
        dashborad_normal: {
            view: "查看儀表板"
        },
        dashborad_admin: {
            view: "查看儀表板和收入报告"
        },
        package_admin: {
            create: "創建套餐",
            update: "更新套餐",
            delete: "刪除套餐",
        },
        operation: {
            detailed_report: "創建詳細報告",
        },
        header: {
            Organization1: "組織 (管理員)",
            Organization2: "組織 (一般)",
            User1: "用戶 (管理員)",
            User2: "用戶 (一般)",
            Subject1: "受試者 (管理員)",
            Subject2: "受試者 (一般)",
            UserGroup1: "用戶群組 (管理員)",
            UserGroup2: "用戶群組 (一般)",
            DataExport1: "數據導出 (管理員)",
            DataExport2: "數據導出 (一般)",
            Dashboard1: "儀表板 (管理員)",
            Dashboard2: "儀表板 (一般)",
            Payment: "付款 (管理員)",
            Operation: "操作",
        },
        remind: {
            title: "ACL (存取控制列表) 角色 !",
            content1: "1. 管理員: 在系統中所有組織擁有完整的存取權限。",
            content2: "2. 一般: 在他們所屬的組織內擁有完整的存取權限。",
            content3: "管理員角色授予系統全域權限，而一般角色則限制訪問到用戶特定的組織。",
        }
    }, paymentRecord: {
        transactionRecord: "交易記錄",
        transactionDate: "交易日期",
        transactionId: "交易ID",
        product: "購買的產品",
        status: "狀態",
        quotaLeft: "剩餘配額",
        buyerInformation: "買方信息",
        invoice: "發票",
        dialog: {
            title: "選擇語言",
            loading: "下載中...",
        },
    }, "BannedIP": {
        "bannedAt": "封鎖時間",
        "ip": "IP位址",
        "unban": "解除封鎖",
        "banned": "已封鎖",
        "configureLimit": "設定限制",
        "dialog": {
            "title": "登入嘗試限制設定",
            "errorSource": "錯誤來源",
            "timeLimit": "時間限制（分鐘）",
            "maxAttempts": "最大嘗試次數",
            "lastUpdated": "最後更新",
            "actions": "操作",
            "ipBased": "IP位址限制",
            "userBased": "用戶限制",
            "minutes": "分鐘",
            "attempts": "次",
            "save": "儲存",
            "cancel": "取消",
            "retry": "重試"
        }
    }, "Cooperation": {
        "title": "合作"
    }, trialAccount: {
        createButton: "創建試用帳戶",
        username: "用戶名",
        email: "電子郵件",
        password: "密碼",
        firstName: "名字",
        lastName: "姓氏",
        gender: "性別",
        organizationName: "組織名稱",
        trialDays: "試用天數",
        quota: "配額",
        male: "男",
        female: "女",
        other: "其他",
        cancel: "取消",
        create: "創建",
        success: "試用帳戶創建成功",
        error: "創建試用帳戶失敗"
    }, warning: {
        imageChecker: {
            multipleIssues: "圖片載入時發現安全警告",
        },
    } });
export default customChineseMessages;
